import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray, getFormValues } from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { setModoTela, initForm } from './manutencaoActions';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') return 0;
    const texto = valor.toString();
    const resultado = Number(
        texto.includes(',') ? texto.replace(/\./g, '').replace(',', '.') : texto
    );
    return Number.isFinite(resultado) ? resultado : 0;
};

const renderItens = ({ fields, readOnly }) => (
    <div style={{
        width: 'calc(100% - 30px)',
        margin: '8px 15px 12px',
        padding: '16px 16px 6px',
        border: '1px solid #d6dee8',
        borderRadius: 12,
        background: '#ffffff',
        boxShadow: '0 2px 8px rgba(15, 35, 60, .05)'
    }}>
        <div style={{
            display: 'flex', justifyContent: 'space-between',
            alignItems: 'center', marginBottom: 10
        }}>
            <strong style={{ color: '#062042', fontSize: 17 }}>
                <i className='fas fa-list' style={{ marginRight: 8 }} />
                Itens da manutenção
            </strong>
            {!readOnly &&
                <button
                    type='button'
                    className='btn btn-success'
                    onClick={() => fields.push({ descricao: '', valor: 0 })}
                >
                    <i className='fas fa-plus' style={{ marginRight: 7 }} />
                    Adicionar item
                </button>}
        </div>

        {fields.map((item, index) => (
            <div
                key={item}
                style={{
                    padding: '12px 12px 0', marginBottom: 10,
                    border: '1px solid #dce3eb', borderRadius: 9,
                    background: '#f8fafc'
                }}
            >
                <Row>
                    <Field
                        name={`${item}.descricao`}
                        component={LabelAndInput}
                        label={`Descrição do item ${index + 1} *`}
                        placeholder='Ex.: troca de óleo, filtro, mão de obra'
                        cols='12 8 8 8'
                        readOnly={readOnly ? 'readOnly' : ''}
                    />
                    <Field
                        name={`${item}.valor`}
                        component={LabelAndInputNumber}
                        label='Valor *'
                        placeholder='0,00'
                        casas={2}
                        cols='9 3 3 3'
                        readOnly={readOnly ? 'readOnly' : ''}
                    />
                    {!readOnly &&
                        <Grid cols='3 1 1 1'>
                            <button
                                type='button'
                                className='btn btn-danger'
                                title='Remover item'
                                disabled={fields.length === 1}
                                onClick={() => fields.remove(index)}
                                style={{ marginTop: 29 }}
                            >
                                <i className='fas fa-trash-alt' />
                            </button>
                        </Grid>}
                </Row>
            </div>
        ))}
    </div>
);

let ManutencaoForm = props => {
    const formulario = props.formularioValues || {};
    const readOnly = Boolean(props.excluir);
    const veiculo = (props.veiculos || []).find(
        item => Number(item.id) === Number(formulario.id_veiculo)
    );
    const total = (formulario.itens || []).reduce(
        (soma, item) => soma + numero(item.valor), 0
    );

    const alterarVeiculo = idVeiculo => {
        const selecionado = (props.veiculos || []).find(
            item => Number(item.id) === Number(idVeiculo)
        );
        props.initForm({
            ...formulario,
            id_veiculo: idVeiculo,
            odometro: selecionado && selecionado.odometro
                ? formulario.odometro : null,
            horimetro: selecionado && selecionado.horimetro
                ? formulario.horimetro : null
        });
    };

    return (
        <ContentCard>
            <Form event={props.handleSubmit}>
                <ContentCardBody>
                    <Row>
                        <Field
                            name='datahora_manutencao'
                            component={LabelAndInput}
                            type='datetime-local'
                            label='Data e hora *'
                            cols='12 4 3 3'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                        <Field
                            name='id_veiculo'
                            component={Select}
                            options={props.veiculos}
                            label='Veículo *'
                            cols='12 8 5 5'
                            readOnly={readOnly ? 'readOnly' : ''}
                            value={formulario.id_veiculo}
                            onChange={alterarVeiculo}
                        />
                        {veiculo && veiculo.odometro &&
                            <Field
                                name='odometro'
                                component={LabelAndInputNumber}
                                label='Odômetro *'
                                casas={1}
                                cols='12 3 2 2'
                                readOnly={readOnly ? 'readOnly' : ''}
                            />}
                        {veiculo && veiculo.horimetro &&
                            <Field
                                name='horimetro'
                                component={LabelAndInputNumber}
                                label='Horímetro *'
                                casas={1}
                                cols='12 3 2 2'
                                readOnly={readOnly ? 'readOnly' : ''}
                            />}
                    </Row>
                    <Row>
                        <Field
                            name='descricao'
                            component={LabelAndTextarea}
                            label='Descrição geral *'
                            placeholder='Descreva o serviço realizado e as observações relevantes'
                            rows={3}
                            cols='12 12 12 12'
                            readOnly={readOnly ? 'readOnly' : ''}
                        />
                    </Row>
                    <Row>
                        <FieldArray
                            name='itens'
                            component={renderItens}
                            readOnly={readOnly}
                        />
                    </Row>
                    <div style={{
                        textAlign: 'right', fontSize: 20, fontWeight: 700,
                        color: '#14532d', padding: '8px 4px 2px'
                    }}>
                        Total: R$ {FormatUtils.formatarValorTela(total, 2)}
                    </div>

                    {formulario.id &&
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 24,
                            marginTop: 16,
                            padding: '12px 16px',
                            border: '1px solid #d6dee8',
                            borderRadius: 10,
                            background: '#f8fafc',
                            color: '#475569'
                        }}>
                            <div>
                                <strong>Criado por:</strong>{' '}
                                {formulario.nome_usuario_inclusao || '-'}
                            </div>
                            <div>
                                <strong>Alterado por:</strong>{' '}
                                {formulario.nome_usuario_alteracao || '-'}
                            </div>
                        </div>}
                </ContentCardBody>
                <ContentCardFooter>
                    <Row alignCenter>
                        <Grid cols='6 6 4 3'>
                            <Button
                                text='Voltar'
                                type='light'
                                icon='fa fa-chevron-left'
                                event={() => props.setModoTela('lista')}
                            />
                        </Grid>
                        <Grid cols='6 6 4 3'>
                            {props.excluir
                                ? <Button text='Excluir' submit type='danger' icon='fa fa-trash' />
                                : <Button text='Salvar' submit type='success' icon='fa fa-check' />}
                        </Grid>
                    </Row>
                </ContentCardFooter>
            </Form>
        </ContentCard>
    );
};

ManutencaoForm = reduxForm({
    form: 'manutencaoForm',
    destroyOnUnmount: false
})(ManutencaoForm);

const mapStateToProps = state => ({
    formularioValues: getFormValues('manutencaoForm')(state),
    veiculos: state.manutencao.veiculos
});

const mapDispatchToProps = dispatch => bindActionCreators({
    setModoTela,
    initForm
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManutencaoForm);
